import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import { Shadows } from 'builder/styles/shadows'

export const TabContainer = styled.div`
  position: sticky;
  top: 0;
  background-color: ${Colors.White};
  z-index: 5;
  padding-top: 12px;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;

  color: ${Colors.Neutral90};
  background: ${Colors.White};
  border-radius: 16px 16px 0 0;
  height: 100vh;
  box-shadow: ${Shadows.dark.high};

  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    width: 0;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: transparent;
  }
`
